import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { MERCH_AVAILABLE } from "./content";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem("gremlin_cart")) || [];
      return MERCH_AVAILABLE ? saved : saved.filter((i) => (i.kind || "coffee") === "coffee");
    } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("gremlin_cart", JSON.stringify(items)); }, [items]);

  const add = useCallback((product, qty = 1, kind = "coffee", price = null) =>
    setItems((prev) => {
      const ex = prev.find((i) => i.id === product.id && (i.kind || "coffee") === kind);
      if (ex) return prev.map((i) => (i.id === product.id && (i.kind || "coffee") === kind ? { ...i, qty: i.qty + qty } : i));
      return [...prev, { id: product.id, name: product.name, accent: product.accent || "#E08C2D", qty, kind, price }];
    }), []);

  const setQty = useCallback((id, qty) =>
    setItems((prev) => (qty <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty } : i)))), []);

  const remove = useCallback((id) => setItems((prev) => prev.filter((i) => i.id !== id)), []);
  const clear = useCallback(() => setItems((prev) => (prev.length ? [] : prev)), []);

  const isCoffee = (i) => (i.kind || "coffee") === "coffee";
  const totalBags = items.filter(isCoffee).reduce((s, i) => s + i.qty, 0);
  const unitPrice = totalBags >= 3 ? 17.99 : 19.99;
  const merchTotal = items.filter((i) => !isCoffee(i)).reduce((s, i) => s + (i.price || 0) * i.qty, 0);
  const totalItems = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = +(totalBags * unitPrice + merchTotal).toFixed(2);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, totalBags, totalItems, unitPrice, subtotal, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
